import { render, staticRenderFns } from "./PageSecondary.vue?vue&type=template&id=451354c0&scoped=true&"
import script from "./PageSecondary.vue?vue&type=script&lang=js&"
export * from "./PageSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451354c0",
  null
  
)

export default component.exports